import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

export default function PaymentSuccessPage() {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/app/landlord/settings');
        }, 5000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)',
        }}>
            <div style={{
                background: '#fff',
                borderRadius: '28px',
                padding: '4rem',
                maxWidth: '480px',
                width: '90%',
                textAlign: 'center',
                boxShadow: '0 25px 50px -12px rgba(0,0,0,0.1)',
                border: '1px solid #d1fae5',
            }}>
                <div style={{
                    width: '80px', height: '80px',
                    background: 'linear-gradient(135deg, #10b981, #059669)',
                    borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 2rem',
                    boxShadow: '0 12px 24px -6px rgba(16, 185, 129, 0.4)',
                }}>
                    <CheckCircle2 size={40} color="#fff" />
                </div>

                <h1 style={{ fontSize: '2rem', fontWeight: 900, letterSpacing: '-0.04em', color: '#1a1d2e', margin: '0 0 1rem' }}>
                    You're all set!
                </h1>
                <p style={{ fontSize: '1.0625rem', color: '#64748b', fontWeight: 500, lineHeight: 1.6, margin: '0 0 2.5rem' }}>
                    Your subscription is now active. Your plan has been upgraded — you can now add unlimited properties.
                </p>

                <button
                    onClick={() => navigate('/app/landlord/settings')}
                    style={{
                        display: 'inline-flex', alignItems: 'center', gap: '8px',
                        padding: '1rem 2.5rem',
                        background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
                        color: '#fff', border: 'none', borderRadius: '16px',
                        fontSize: '1rem', fontWeight: 700, cursor: 'pointer',
                        boxShadow: '0 10px 20px -6px rgba(99, 102, 241, 0.4)',
                    }}
                >
                    Go to Settings
                </button>

                <p style={{ marginTop: '1.5rem', fontSize: '0.8125rem', color: '#94a3b8' }}>
                    Redirecting automatically in 5 seconds...
                </p>
            </div>
        </div>
    );
}
